import avatar from "../assets/images/avatar.png";

/** Shared header strip height so all TicketV2 columns’ `border-bottom` align (Figma). */
export const TV2_COLUMN_HEADER_HEIGHT = 64;

export const INBOX_FILTERS = [
  { id: "all", label: "All" },
  { id: "assigned_to_me", label: "Assigned to Me" },
  { id: "unassigned", label: "Unassigned" },
  { id: "closed", label: "Solved" },
  { id: "spam", label: "Spam" },
];

export const FOLDERS = [
  { id: "vip", label: "VIP Support" },
  { id: "bugs", label: "Bugs Reports" },
  { id: "features", label: "Feature Requests" },
  { id: "billing", label: "Billing" },
];

export const VIEWS = [
  {
    id: "jane-smith",
    label: "Jane Smith",
    openCount: 4,
  },
];

export const TICKETS = [
  {
    id: "11009",
    /** Backend ticket id for ticket APIs (requester / group popups); replace with a real id when testing live data */
    _id: "507f1f77bcf86cd799439011",
    customerName: "Eleanor Pena",
    avatar,
    preview: "I heard it's a great spot for ...",
    time: "Now",
    unread: true,
    selected: true,
    subject: "Unable to login to account",
    status: "open",
    priority: "",
    assignee: "",
    tags: ["Help"],
    source: "Contact form",
    created: "August 2, 2013",
    lastMessage: "February 9, 2015",
    requester: {
      name: "Annette Black",
      email: "kenzi.lawson@example.com",
      avatar,
    },
    ccEmails: [],
    group: {
      _id: "507f1f77bcf86cd799439012",
      name: "NSO Orientation",
      members: 8,
    },
    history: ["Unable to login to account", "What's up with you these day ..."],
    createdBy: {
      name: "Kristin Watson",
      email: "kristin@example.com",
    },
  },
  {
    id: "11003",
    customerName: "Leslie Alexander",
    avatar,
    preview: "What's up with you these day ...",
    time: "10d 8h",
  },
  {
    id: "11001",
    customerName: "Kristin Watson",
    avatar,
    preview: "What's up with you these day ...",
    time: "10d 8h",
  },
  {
    id: "11005",
    customerName: "Darlene Robertson",
    avatar,
    preview: "What's up with you these day ...",
    time: "10d 8h",
  },
  {
    id: "11008",
    customerName: "Jenny Wilson",
    avatar,
    preview: "What's up with you these day ...",
    time: "10d 8h",
  },
  {
    id: "11004",
    customerName: "Wade Warren",
    avatar,
    preview: "What's up with you these day ...",
    time: "10d 8h",
  },
  {
    id: "11007",
    customerName: "Kathryn Murphy",
    avatar,
    preview: "What's up with you these day ...",
    time: "10d 8h",
  },
  {
    id: "11006",
    customerName: "Theresa Webb",
    avatar,
    preview: "What's up with you these day ...",
    time: "10d 8h",
  },
];

export const MESSAGES = [
  {
    id: "m1",
    type: "received",
    avatar,
    text:
      "Hi, I've been trying to log into my account for the past hour but keep getting an error message saying 'Invalid credentials' even though I'm sure my password is correct. I've tried resetting it twice but still having the same issue. This is really urgent as I need to access my documents for a meeting in 2 hours.",
    attachment: { name: "Tech requirements.pdf", size: "1.2 MB" },
    time: "01:34 pm",
  },
  {
    id: "m2",
    type: "sent",
    avatar,
    text:
      "Hi Sarah, thanks for reaching out. I'm sorry to hear you're having trouble accessing your account. I've looked into your account and I can see the issue. It appears your account was temporarily locked due to multiple failed login attempts. I've unlocked it for you now. Please try logging in again with your current password.",
    time: "01:34 pm",
  },
  {
    id: "m3",
    type: "internal",
    avatar,
    text: "Hi Sarah, thanks for reaching out.",
    time: "01:34 pm",
  },
];

export const TICKET_PROPERTY_OPTIONS = {
  status: ["Open", "Pending", "Solved", "Spam"],
  priority: ["Low", "Medium", "High", "Urgent"],
};
